import styled from 'styled-components'
import { fontSizes, fontWeights } from 'syf-component-library/defaultTheme'
import { Body } from 'syf-component-library/ui/typography'

export const TextWrapper = styled.div`
  text-align: center;
  font-size: ${fontSizes.medium}px;
  font-weight: ${fontWeights.bold};
`

export const Description = styled(Body)`
  text-align: center;
`
